import { AWARD_PAYMENT } from '../constants/general';

export const awardStatusColorMap: Record<string, string> = {
  [AWARD_PAYMENT.DRAFT]: 'text-yellow',
  [AWARD_PAYMENT.UNDER_REVIEW]: 'text-light-blue',
  [AWARD_PAYMENT.NEED_MORE_INFORMATION]: 'text-dark-yellow',
  [AWARD_PAYMENT.APPROVED]: 'text-brand-navy',
  [AWARD_PAYMENT.PAID]: 'text-evergreen',
  [AWARD_PAYMENT.EXPIRED]: 'text-maroon',
  [AWARD_PAYMENT.CANCELED]: 'text-blue',
};

export const getStatusColorClass = (status?: string | null): string => {
  const statusNormalized = (status ?? '').trim().toLowerCase();
  return awardStatusColorMap[statusNormalized] || 'text-brand-navy';
};
